// Imports => Constants
import { TITLES } from '@constants';

export const AcSetDocumentTitle = title => {
	document.title = `${TITLES.BASE} - ${title}`;
};

export default AcSetDocumentTitle;
